import axios from "axios";
import { urlBase } from "./Api";

const PublicApi = () => axios.create({
  baseURL: urlBase,
  headers: {
    Accept: "application/json",
  },
  timeout: 30000,
});

export default PublicApi;
